import { Component, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from './shared/services/auth.service';
import { IdiolTimeoutServiceService } from './shared/services/idiol-timeout-service.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrl: './app.component.css'
})
export class AppComponent {
  title = 'MSSIDC_Angular';

  @HostListener('window:load')
  @HostListener('window:resize')
  preventClickjacking() {
    if (window.top && window.top !== window.self) {
      // Ensure `window.top` exists before accessing `location`
      window.top.location.href = window.self.location.href;
    }
  }

  //constructor(private authService: AuthService, private idleTimeoutService: IdiolTimeoutServiceService, private router: Router) { }

  


  constructor(private authService: AuthService, private idleTimeoutService: IdiolTimeoutServiceService, private router: Router) {
     //Disable right-click context menu
    document.addEventListener('contextmenu', (e) => {
      e.preventDefault();
    });

    
  }

  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    // Disable F12
    if (event.key === 'F12') {
      event.preventDefault();
      return false;
    }
    // Disable Ctrl+Shift+I (Inspect Element)
    if (event.ctrlKey && event.shiftKey && event.key === 'I') {
      event.preventDefault();
      return false;
    }
    // Disable Ctrl+Shift+C (Inspect Element specific)
    if (event.ctrlKey && event.shiftKey && event.key === 'C') {
      event.preventDefault();
      return false;
    }
    // Disable Ctrl+Shift+J (Console)
    if (event.ctrlKey && event.shiftKey && event.key === 'J') {
      event.preventDefault();
      return false;
    }
    // Disable Ctrl+U (View Source)
    if (event.ctrlKey && event.key === 'U') {
      event.preventDefault();
      return false;
    }
    return true; // Allow other keyboard events
  }



  ngOnInit(): void {
    this.idleTimeoutService.startMonitoring();
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe(() => {
        window.scrollTo(0, 0); // This will scroll to the top
      });
}
}
